/**
 * This file contains head tags that are common use by www.domain.com.au pages.
 */

/**
 * Domain.com.au specific head tags
 */
const domainHeadTagList = [
  {
    tagName: 'meta',
    props: {
      name: 'apple-mobile-web-app-capable',
      content: 'yes',
    },
  },
  {
    tagName: 'meta',
    props: {
      name: 'theme-color',
      content: '#0ea800',
    },
  },
  {
    tagName: 'link',
    props: {
      rel: 'apple-touch-icon-precomposed',
      href: 'https://s.domainstatic.com.au/domain/54.png',
    },
  },
  {
    tagName: 'link',
    props: {
      rel: 'apple-touch-icon-precomposed',
      size: '72x72',
      href: 'https://s.domainstatic.com.au/domain/72.png',
    },
  },
  {
    tagName: 'link',
    props: {
      rel: 'apple-touch-icon-precomposed',
      size: '114x114',
      href: 'https://s.domainstatic.com.au/domain/114.png',
    },
  },
  {
    tagName: 'link',
    props: {
      rel: 'apple-touch-icon-precomposed',
      size: '144x144',
      href: 'https://s.domainstatic.com.au/domain/144.png',
    },
  },
  {
    tagName: 'link',
    props: {
      rel: 'shortcut icon',
      href: 'https://s.domainstatic.com.au/domain/favicon.ico',
    },
  },

  // see: https://web.dev/codelab-preload-web-fonts/
  // and: https://web.dev/font-display/?utm_source=lighthouse&utm_medium=devtools
  {
    tagName: 'link',
    props: {
      rel: 'preload',
      href: 'https://s.domainstatic.com.au/content/fe-static/@domain-group/fe-brary/static/fonts/bolton/F37Bolton-Regular.woff2',
      as: 'font',
      type: 'font/woff2',
      crossOrigin: 'true',
    },
  },
  {
    tagName: 'link',
    props: {
      rel: 'preload',
      href: 'https://s.domainstatic.com.au/content/fe-static/@domain-group/fe-brary/static/fonts/bolton/F37Bolton-Bold.woff2',
      as: 'font',
      type: 'font/woff2',
      crossOrigin: 'true',
    },
  },
];

module.exports = domainHeadTagList;
